import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../components/Layout'
import { Helmet } from 'react-helmet'

import CTA from '../components/CTA'
import Header from '../components/Header'
import FAQs from '../components/FAQs'

export default () => (
  <Layout>
    <Helmet>
      <title>FAQ’s - GFit Sportswear</title>
    </Helmet>
    <Header>
      <h1>Frequently asked questions</h1>
    </Header>
    <FAQs />
    <CTA
      title="Having an issue?"
      subtitle="We’re here to help you."
      button="Contact Us"
    />
  </Layout>
)
